import { DataService } from './dataService'

const HsCodeDutyTaxesService = {
	getHscodeaddutytaxes: async(data) => {
		return DataService.get('/admin/hscode_duty_taxes', data)
	},
	importHsCodeDutyTax: async (data) => {
        return DataService.post('/admin/hscode_duty_taxes/import', data)
    },
    exportHsCodeDutyTax: async (data) => {
        return DataService.get('/admin/hscode_duty_taxes/export', data)
    },
}

export default HsCodeDutyTaxesService